<script lang="ts" setup>
import { show as intercomShow } from '@intercom/messenger-js-sdk'

import type { NuxtError } from '#app'

type Props = {
  error: NuxtError
}

defineProps<Props>()

// Since this is not a page per say we can't resort to onMounted :<
// So this is the best work around I got rn
if (import.meta.client) {
  window.setTimeout(() => {
    try {
      intercomShow()
    } catch (_) {
      // Mute error
    }
  }, 1500)
}
</script>

<template>
  <NuxtLayout name="default">
    <div id="ignoreFontUpscale" class="mainParentContainer ignoreFontUpscale">
      <div
        class="tw-grid tw-justify-center tw-gap-2xl tw-pt-2xl tw-text-center"
      >
        <h1 class="tw-text-h5">
          {{ $t('error.00') }}
        </h1>
        <h2 class="tw-text-h6">
          {{ $t('error.01') }} {{ error.statusCode }} error
        </h2>
        <div class="tw-grid tw-gap-14">
          <div class="tw-grid tw-gap-lg">
            <span class="tw-text-body">
              {{ $t('error.02') }}
            </span>
          </div>
          <p class="tw-text-body">
            {{ $t('error.cringe') }}
          </p>
          <ul
            class="tw-grid tw-list-disc tw-justify-start tw-gap-sm tw-text-left"
          >
            <li class="tw-text-body">
              {{ $t('error.refresh') }}
            </li>
            <li class="tw-text-body">
              {{ $t('error.updateYourBrowser') }}
            </li>
            <li class="tw-text-body">
              {{ $t('error.contactSupport') }}
            </li>
          </ul>
          <div>
            <span class="tw-text-body">{{ $t('error.04') }}</span>
            <NuxtLinkLocale to="/">
              <span class="tw-text-body tw-font-medium tw-text-primary"
                >groover.co</span
              >
            </NuxtLinkLocale>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
